import { Component, OnInit } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
// import { PatientService } from "src/app/core/services/v2/patient.service";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
// import { UserService } from "src/app/core/services/v2/user.service";

import { PDFDialogComponent } from "src/app/signup-organization/pdf-dialog/pdf-dialog.component";
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/core/services/v2/user.service';
import { PatientService } from 'src/app/core/services/v2/patient.service';


@Component({

  selector: "app-patient-subscriptions",

  templateUrl: "./patient-subscriptions.component.html",

  styleUrls: ["./patient-subscriptions.component.scss"],

})

export class PatientSubscriptionsComponent implements OnInit {

  user: any = [];
  subscriptionType: number;
  selectedType: number = 0;
  activationType: string;
  // isMySubscriptionsTabActive: boolean = false;
   userId:number;
  employerId:number;
  patientName:string;
  profileData: any = [];
  // selectedPaymentTab: string = '';
  isMySubscriptionsTabActive: boolean = false;
  selectedPaymentTab: string = '';
  showChoosePlan: boolean = true;
  showActivePlan: boolean = true;
  showPaymentMethod: boolean = true;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private _patientService: PatientService,
    private loaderService: WindowLoaderService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.getUserDetails();
    // Listen to route changes to toggle the view

  

  }
  onTabClick1(tabId: string): void {
    this.isMySubscriptionsTabActive = tabId === 'surgicalHistory';
  }
  onTabClickPayment1(tabId: string): void {
    this.selectedPaymentTab = tabId;
  }
  getUserDetails() {
    this.loaderService.show();
    this.userService.getUserDetails().subscribe(
      (userDetails) => {
        console.log("userdetails",userDetails);
        this.user = userDetails;
        console.log("user", this.user);
        this.userId = userDetails.id;
        this.employerId = userDetails.employerId;
        this.patientName = userDetails.name
        // this.patientId = userDetails.patientId
        console.log("This is userId: ", this.userId);
        // console.log("This is patientId: ", this.patientId);
        // this.getPatientHealthSubscriptionByEmployerId();
        this.getCurrentPatientData();

      },
      (error) => { console.error(error); }
    );
  }
  getCurrentPatientData(): void {
    this.loaderService.blockWithLoader(this._patientService.getCurrentPatientDetails()).subscribe(
      (data) => {
        if (data) {
          console.log("patient current ptrofile data",data)
          this.profileData = data;
          // this.employerName = data.employerName;
      
        }
      },
      (error) => { console.error(error); },
    )
  }
  // setTypeValue(value: number) {
  //   this.selectedType = value;
  //   // Set activation type based on selection
  //   this.activationType = value > 0 ? "Activate" : "Deactivate";
  // }

  // getUserDetails() {
  //   this.loaderService.show();
  //   this._userService.getUserDetails().subscribe(
  //     (result) => {
  //       this.user = result;
  //       console.log("user", this.user);
  //       this.getPatientSubscriptionDetailsByPatientId();
  //     },
  //     (error) => {
  //       console.error(error);
  //     }
  //   );
  // }

  // getPatientSubscriptionDetailsByPatientId() {
  //   this.loaderService.show();
  //   this._patientService
  //     .getPatientSubscriptionDetailsByPatientId(this.user.patientId)
  //     .subscribe(
  //       (result) => {
  //         console.log("Subscription Details:", result);
  //         this.subscriptionType = result.subscriptionTypeId;
  //         console.log("Patient Subscription Type:", this.subscriptionType);
  //         this.loaderService.hide();
  //       },
  //       (error) => {
  //         console.error("Error fetching subscription details:", error);
  //         this.loaderService.hide();
  //       }
  //     );
  // }

  // updatePatientHealthSubscription() {
  //   // this.router.navigate(['/employer/subscription-method/setupCheckout']);

  //   // this.loaderService.show();
  //   document.getElementById("clsModal").click();

  //   this.router
  //     .navigate(['/employer/setupCheckout'])
  //     .then(() => {
  //       this.loaderService.hide();
  //     });
  // }

    // updatePatientHealthSubscription() {
    //   this.router.navigate(['employer/subscription-method/setupCheckout']);
    // }




  // cancelSubscription() {
  //   this.loaderService.show();
  //   this.activationType = "Deactivate";
  //   // Call the service to update the subscription
  //   this._patientService
  //     .updatePatientHealthSubscription(
  //       this.user.patientId,
  //       this.selectedType,
  //       this.activationType
  //     )
  //     .subscribe(
  //       (result) => {
  //         console.log("result update", result);
  //         this.subscriptionType = this.selectedType;
  //         this.activationType = this.activationType;
  //         console.log("subscriptionType", this.subscriptionType);
  //         console.log("activationType", this.activationType);
  //           // Call to fetch updated subscription details
  //           this.getUserDetails();
  //         this.loaderService.hide();
  //         document.getElementById("clsModalCancel").click();

  //       },
  //       (error) => {
  //         console.error(error);
  //         this.loaderService.hide();
  //       }
  //     );
  // }

  // openPdfDialog(type: number) {
  //   let data = {
  //     title: "Appy Health Pricing",
  //     filename:
  //       "Appy Health Enhanced Benefit Solution _New Benefits complete[13186].pdf",
  //   };
  //   if (type === 2) {
  //     data = {
  //       title: "Appy Health Money Back Guarantee",
  //       filename: "AH-Money-Back-Guarantee-11.14.2022-D5.pdf",
  //     };
  //   } else if (type === 3) {
  //     data = {
  //       title: "Appy Health Cancellation Policy",
  //       filename: "AH-Cancellation-Policy-11.14.2022-D9.pdf",
  //     };
  //   }

  //   this.dialog.open(PDFDialogComponent, {
  //     panelClass: "pricing-pdf-modal",
  //     id: "subscription_dialog",
  //     data: { ...data, isBack: false },
  //   });
  // }
  getValidAddress(profileData: any): any {
    if (!profileData || !profileData.addresses || profileData.addresses.length === 0) {
      return null;
    }
  
    // Find the first address that has at least one meaningful field (line, city, state, zipCode)
    return profileData.addresses.find(addr => addr.line || addr.city || addr.state || addr.zipCode) || null;
  }
  
  getFormattedAddress(address: any): string {
    if (!address) return '';
  
    const parts = [];
    if (address.line) parts.push(address.line);
    if (address.city) parts.push(address.city);
    if (address.state) parts.push(address.state);
    if (address.zipCode) parts.push(address.zipCode);
  
    return parts.join(', ');
  }
  
  onTabClick(tabId: string): void {
    console.log('Tab changed to:', tabId);

    this.isMySubscriptionsTabActive = tabId === 'surgicalHistory';
    if (tabId === 'surgicalHistory') {
      this.showActivePlan = false;
      setTimeout(() => this.showActivePlan = true, 0); // triggers re-render
    }
  }
  
  onTabClickPayment(tabId: string): void {
    console.log('Tab changed to:', tabId);

    this.selectedPaymentTab = tabId;
    if (tabId === 'familyHistory') {
      this.showPaymentMethod = false;
      setTimeout(() => this.showPaymentMethod = true, 0);
    }
  }
  
  onChoosePlanClick(): void {
    console.log('Tab changed to chooseplan:', );

    this.showChoosePlan = false;
    setTimeout(() => this.showChoosePlan = true, 0);
  }
}